import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PointStoreProductLandingService {

  constructor() { }

  makeNewLandingListToolbar() {
    let newLandingListToolbar = {
      selectAll: false,
      toolbarAction: [
        { position: 0, value: false, name: 'import' },

        { position: 1, value: false, name: 'edit' },
        { position: 2, value: false, name: 'copy' },
        { position: 3, value: false, name: 'delete' },
        { position: 4, value: false, name: 'displayOptions' },
        { position: 5, value: false, name: 'assignments' },

        { position: 6, value: false, name: 'multiEdit' },
        { position: 7, value: false, name: 'multiDelete' },

        { position: 8, value: false, name: 'viewProductDetail' },
        { position: 9, value: false, name: 'viewProductImageDetail' },

        { position: 10, value: false, name: 'viewProductDetailHover' },
        { position: 11, value: false, name: 'viewProductImageDetailHover' },

        { position: 12, value: false, name: 'add' },
        { position: 13, value: false, name: 'multiAssignments' },
      ],
    };
    return newLandingListToolbar;
  }

  getNewLandingListToolbar() {
    return this.makeNewLandingListToolbar();
  }
}
